import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useFlattenSalesTeams } from './useFlattenSalesTeams'
import { useGetEmployeeListOnMount } from '@user/store/employee/hooks/useGetEmployeeListOnMount'
import { useGetSalesTeamListOnMount } from '@user/store/salesTeam/hooks'
import { useGetUserListOnMount } from '@user/store/users/hooks/useGetUserListOnMount'
import { selectAllSalesTeams } from '@user/store/salesTeam/slice'
import { selectAllUsers } from '@user/store/users/slice'
import { selectAllEmployees } from '@user/store/employee/slice'
import { isValidEmail } from '@sales-center/common'
import { INotification } from '@user/store/notifications/typings'

export const useFormDataOnMount = (notification: INotification) => {
  //#region fetch data
  const teamStatus = useGetSalesTeamListOnMount()
  const userStatus = useGetUserListOnMount()
  const employeeStatus = useGetEmployeeListOnMount()
  //#endregion

  //#region selectors
  const salesTeams = useSelector(selectAllSalesTeams)
  const users = useSelector(selectAllUsers)
  const allEmployees = useSelector(selectAllEmployees)
  //#endregion

  const activeUsers = useMemo(
    () => users.filter((user) => user.isActive),
    [users],
  )
  //#region mappers
  const loading = useMemo(
    () =>
      teamStatus === 'pending' ||
      userStatus === 'pending' ||
      employeeStatus === 'pending',
    [employeeStatus, teamStatus, userStatus],
  )

  const list = useFlattenSalesTeams(
    salesTeams,
    activeUsers,
    notification.salesTeamHierarchy,
  )

  const emails = useMemo(
    () =>
      allEmployees
        .map(({ workWaveId, email }) => {
          if (isValidEmail(email)) return email
          else if (isValidEmail(workWaveId)) return workWaveId
          return ''
        })
        .filter((email, index, array) =>
          email === '' ? false : array.indexOf(email) === index,
        )
        .sort((a, b) => a.localeCompare(b)),
    [allEmployees],
  )
  //#endregion

  return { loading, list, emails }
}
